var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61402 5.172C8.90302 5.172 7.80277 4.3635 6.64402 4.392C5.11402 4.41225 3.71152 5.27925 2.92327 6.6525C1.33552 9.40875 2.51377 13.4797 4.06252 15.72C4.82227 16.8105 5.71852 18.0375 6.90652 17.9992C8.04652 17.9505 8.47402 17.259 9.85777 17.259C11.231 17.259 11.6203 17.9992 12.8278 17.97C14.0555 17.9505 14.8348 16.86 15.5848 15.759C16.4518 14.493 16.8118 13.2652 16.8313 13.1977C16.802 13.188 14.4448 12.282 14.4163 9.555C14.3968 7.275 16.2763 6.1845 16.364 6.13575C15.2923 4.56825 13.6468 4.39275 13.0715 4.35375C11.5715 4.23675 10.3153 5.17125 9.61402 5.17125V5.172ZM12.1475 2.8725C12.7798 2.1135 13.1975 1.05225 13.0813 0C12.176 0.039 11.0848 0.60375 10.4323 1.3635C9.84727 2.0355 9.34177 3.117 9.47752 4.149C10.481 4.227 11.5138 3.633 12.1468 2.87325",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.svg";
export { ForwardRef as ReactComponent };